<template>
  <v-menu
    v-model="navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible"
    @update:model-value="navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible == false ? navigation.CRMWhatsappInvoicePaymentContextMenuItem = null : null"
    @contextmenu.prevent="null"
    :scrim="true"
    :activator="false"
    :close-on-content-click="false"
    location-strategy="static"
  >
    <v-list 
      density="compact"
      style="position: absolute; width: 300px; height: 220px; max-height: 250px; overflow-y: auto; overflow-x: hidden; display: flex; flex-direction: column; justify-content: center; user-select: none;" 
      :style="`top: ${navigation.CRMWhatsappInvoicePaymentContextMenuY}px; left: ${navigation.CRMWhatsappInvoicePaymentContextMenuX}px;`"
    >
      <v-list-item 
        title="Copiar ID de la orden" 
        @click="$generalFunctions.default.copyToClipboard(this, 'ID de la orden', 'o', navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappInvoiceID); navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible = false; navigation.CRMWhatsappInvoicePaymentContextMenuItem = null;" 
        class="hoverableText" 
        style="overflow-x: hidden;"
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-paperclip</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        title="Copiar orden" 
        @click="copyCRMWhatsappInvoiceToClipboard(); navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible = false; navigation.CRMWhatsappInvoicePaymentContextMenuItem = null;" 
        class="hoverableText" 
        style="overflow-x: hidden;"
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-clipboard-text</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        title="Abrir conversación" 
        @click="$root.dialogComponent.openCRMWhatsappConversationDialog(navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappConversationID); navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible = false; navigation.CRMWhatsappInvoicePaymentContextMenuItem = null;" 
        class="hoverableText" 
        style="overflow-x: hidden;"
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-chat</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        title="Ver productos" 
        @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappInvoiceID]); navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible = false; navigation.CRMWhatsappInvoicePaymentContextMenuItem = null;" 
        class="hoverableText" 
        style="overflow-x: hidden;"
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-cart</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        title="Confirmar pago" 
        @click="$root.dialogComponent.openSINPEPaymentDialog(null, navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappInvoiceID, navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappInvoiceMixedPaymentSINPEAmount ? navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappInvoiceMixedPaymentSINPEAmount : navigation.CRMWhatsappInvoicePaymentContextMenuItem.CRMWhatsappInvoiceAmount); navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible = false; navigation.CRMWhatsappInvoicePaymentContextMenuItem = null;" 
        class="hoverableText" 
        style="overflow-x: hidden;"
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-cash-check</v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
  <div style="user-select: none; cursor: default;" @contextmenu.prevent="null">
    <v-card color="primary" elevation="0" rounded="0" style="height: 100vh; overflow-y: hidden; display: flex; flex-direction: column;">
      <div style="padding: 15px;">
        <div style="display: flex; align-items: center;">
          <v-icon color="indigo" size="large" style="margin-right: 5px;">mdi-cash-multiple</v-icon>
          <v-icon color="indigo" style="margin-right: 10px;">mdi-arrow-right-bold</v-icon>
          <h2>SINPE activos</h2>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; gap: 15px; margin-top: 15px;">
          <v-text-field 
            ref="searchQuery"
            v-model="input.searchQuery"
            @click:prepend-inner="input.searchQuery = null; $generalFunctions.default.focusInput(this, 'searchQuery')"
            :prepend-inner-icon="input.searchQuery && /\S/.test(input.searchQuery) ? 'mdi-magnify-remove-outline' : 'mdi-magnify'"
            :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView"
            :loading="loader.getSystemInformationData || loader.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView"
            label="Búsqueda rápida"
            variant="outlined"
            density="compact" 
            autocomplete="off"
            hide-details
          ></v-text-field>
        </div>
      </div>
      <v-data-table 
        :headers="display.CRMWhatsappInvoicePaymentHeaders" 
        :items="computed_CRMWhatsappInvoicePayment" 
        :items-per-page="-1" 
        :fixed-header="true" 
        :loading="loader.getSystemInformationData || loader.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView"
        no-data-text=""
        hover
        style="flex: 1; overflow: auto; scrollbar-width: thin; -ms-overflow-style: none;"
      >     
        <template v-slot:header.CRMWhatsappInvoiceID>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-barcode</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>ID</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMWhatsappContactID>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-account</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>CONTACTO</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMLocalityID>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-store</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>LOCALIDAD</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMAgentID>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-briefcase-account</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>VENDEDOR</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMWhatsappInvoiceAmount>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-cash-multiple</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>VENTA</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMWhatsappInvoiceOpenCRMWhatsappConversationAction>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-chat</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>CONVERSACIÓN</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMWhatsappInvoiceCRMWhatsappInvoiceProductAction>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-cart</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>PRODUCTOS</strong></span>
          </div>
        </template>
        <template v-slot:header.CRMWhatsappInvoicePaymentAction>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            <v-icon color="indigo" style="margin-right: 5px;">mdi-cash-check</v-icon>
            <span style="margin-right: 10px; display: flex; align-items: center;"><strong>PAGO</strong></span>
          </div>
        </template>
        <template v-slot:item="row">
          <tr 
            @contextmenu.prevent="navigation.CRMWhatsappInvoicePaymentContextMenuIsVisible = true; navigation.CRMWhatsappInvoicePaymentContextMenuItem = row.item; navigation.CRMWhatsappInvoicePaymentContextMenuX = $event.clientX; navigation.CRMWhatsappInvoicePaymentContextMenuY = $event.clientY;"
            :class="navigation.CRMWhatsappInvoicePaymentContextMenuItem?.CRMWhatsappInvoiceID == row.item.CRMWhatsappInvoiceID ? 'selectedVDataTableRow' : null"
          >
            <td>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                <template v-slot:activator="{ props }">
                  <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la ORDEN', 'o', row.item.CRMWhatsappInvoiceID)" class="hoverableText" style="color: #3F51B5"><strong>{{ row.item.CRMWhatsappInvoiceID }}</strong></p>
                </template>
              </v-tooltip>
            </td>
            <td>
              <p style="white-space: nowrap;">{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
              <p style="font-size: small; color: #9e9e9e; white-space: nowrap;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
            </td>
            <td>
              <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMLocalityID).CRMLocalityColor : 'primary'" variant="flat" elevation="2" label>
                <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMLocalityID).CRMLocalityName : 'No registrada' }}</p>
              </v-chip>
            </td>
            <td>
              <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID).CRMAgentColor : 'primary'" variant="flat" elevation="2" label>
                <div style="display: flex; align-items: center;">
                  <img :src="systemInformationData.CRMAgents.find(a => a.CRMAgentID == row.item.CRMAgentID)?.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                  <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID).CRMAgentName : 'No registrado' }}</p>
                </div>
              </v-chip>
            </td>
            <td>
              <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(row.item.CRMWhatsappInvoiceAmount) }}</p>
              <template v-if="row.item.CRMWhatsappInvoiceMixedPaymentSINPEAmount">
                <p style="font-size: small; color: #9e9e9e;">(<span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(row.item.CRMWhatsappInvoiceMixedPaymentSINPEAmount) }})</p>
              </template>
            </td>
            <td>
              <v-btn @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID, false, false, false, true, true, true, false, false, false, false, false, false)" color="primary" class="hoverableText">
                <v-icon style="margin-right: 10px;">mdi-chat</v-icon>
                <p style="font-size: small;">CONVERSACIÓN</p>
              </v-btn>
            </td>
            <td>
              <v-btn @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([row.item.CRMWhatsappInvoiceID])" color="primary" class="hoverableText">
                <v-icon style="margin-right: 10px;">mdi-package</v-icon>
                <p style="font-size: small;">PRODUCTOS</p>
              </v-btn>
            </td>
            <td>
              <v-btn @click="$root.dialogComponent.openSINPEPaymentDialog(null, row.item.CRMWhatsappInvoiceID, row.item.CRMWhatsappInvoiceMixedPaymentSINPEAmount ? row.item.CRMWhatsappInvoiceMixedPaymentSINPEAmount : row.item.CRMWhatsappInvoiceAmount)" color="primary" class="hoverableText">
                <v-icon style="margin-right: 10px;">mdi-cash-check</v-icon>
                <p style="font-size: small;">CONFIRMAR PAGO</p>
              </v-btn>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div v-if="computed_CRMWhatsappInvoicePayment.length != display.CRMWhatsappInvoicePayment.length" @click="input.searchQuery = null; $generalFunctions.default.focusInput(this, 'searchQuery')" class="hoverableText" style="text-align: center; padding: 20px;">
            <v-icon size="large" color="indigo">mdi-information</v-icon>
            <div style="margin-top: 10px; color: #9e9e9e;">
              <p>No se encontraron pagos por SINPE activos con el criterio de búsqueda "<strong>{{ input.searchQuery }}</strong>"</p>
              <p>Haz click <span class="hoverableText" style="text-decoration: underline; color: #3F51B5;"><strong>aquí</strong></span> para limpiar el criterio de búsqueda</p>
            </div>
          </div>
          <div v-else @click="input.searchQuery = null" class="hoverableText" style="text-align: center; padding: 20px; gap: 10px;">
            <v-icon size="large" color="indigo">mdi-information</v-icon>
            <p style="color: #9e9e9e;">No existen pagos por SINPE activos</p>
          </div>
        </template>
        <template v-slot:loading>
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 20px; gap: 10px;">
            <v-icon size="large" color="indigo">mdi-clock</v-icon>
            <p style="color: #9e9e9e;">Cargando lista de pagos por SINPE activos...</p>
          </div>
        </template>
        <template v-slot:bottom></template>
      </v-data-table>
      <div style="height: 50px; display: flex; justify-content: flex-end; align-items: center;">
        <p style="margin-right: 15px; font-size: small;">Mostrando <strong>{{ computed_CRMWhatsappInvoicePayment.length }}</strong> de <strong>{{ display.CRMWhatsappInvoicePayment.length }}</strong> pago{{ display.CRMWhatsappInvoicePayment.length > 1 ? 's' : '' }} por SINPE activo{{ display.CRMWhatsappInvoicePayment.length > 1 ? 's' : '' }}</p>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: {},
    data: () => ({
      input: 
      {
        searchQuery: null
      },
      display: 
      {
        CRMWhatsappInvoicePaymentHeaders: 
        [
          {title: 'ID', key: 'CRMWhatsappInvoiceID', sortable: false},
          {title: 'CONTACTO', key: 'CRMWhatsappContactID', sortable: false},
          {title: 'LOCALIDAD', key: 'CRMLocalityID', sortable: false},
          {title: 'VENDEDOR', key: 'CRMAgentID', sortable: false},
          {title: 'VENTA', key: 'CRMWhatsappInvoiceAmount', sortable: false},
          {title: 'CONVERSACIÓN', key: 'CRMWhatsappInvoiceOpenCRMWhatsappConversationAction', sortable: false},
          {title: 'PRODUCTOS', key: 'CRMWhatsappInvoiceCRMWhatsappInvoiceProductAction', sortable: false},
          {title: 'PAGO', key: 'CRMWhatsappInvoicePaymentAction', sortable: false}
        ],
        CRMWhatsappInvoicePayment: []
      },
      navigation: 
      {
        CRMWhatsappInvoicePaymentContextMenuIsVisible: false,
        CRMWhatsappInvoicePaymentContextMenuItem: null,
        CRMWhatsappInvoicePaymentContextMenuX: 0,
        CRMWhatsappInvoicePaymentContextMenuY: 0
      },
      loader: 
      {
        getSystemInformationData: false,
        selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView: false
      },
      interval: 
      {
        selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewInterval: null
      },
      websocketCallback: 
      {
        confirmSINPEPaymentForCRMWhatsappInvoice: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        CRMLocalities: [],
        CRMAgents: [],
        updateSubscription: null
      },

    }),

    computed: 
    {
      computed_CRMWhatsappInvoicePayment(){
        let filteredCRMWhatsappInvoicePayment = JSON.parse(JSON.stringify(this.display.CRMWhatsappInvoicePayment));
        if (this.input.searchQuery){
          filteredCRMWhatsappInvoicePayment = filteredCRMWhatsappInvoicePayment.filter(CRMWhatsappInvoice => 
            CRMWhatsappInvoice.CRMWhatsappInvoiceID.toString().toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(CRMWhatsappInvoice).toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            this.systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMWhatsappInvoice.CRMLocalityID)?.CRMLocalityName?.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMWhatsappInvoice.CRMAgentID)?.CRMAgentName?.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappInvoice.CRMWhatsappInvoiceAmount.toString().toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappInvoice.CRMWhatsappInvoiceProducts.some(CRMWhatsappInvoiceProduct => CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductProductID.toLowerCase().includes(this.input.searchQuery.toLowerCase())) ||
            CRMWhatsappInvoice.CRMWhatsappInvoiceProducts.some(CRMWhatsappInvoiceProduct => CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductName.toLowerCase().includes(this.input.searchQuery.toLowerCase()))

          );
        }
        return filteredCRMWhatsappInvoicePayment;
      }
    },

    methods: 
    {
      async selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView(pageLoad) {
        if (pageLoad) this.loader.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView = true;
        const selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappInvoice/functions/selectCRMWhatsappInvoiceFromCurrentCRMWhatsappInvoicePaymentView', selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewRequestQuery);
        if (selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewResult.success){
          this.display.CRMWhatsappInvoicePayment = selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewResult.result;
          this.display.CRMWhatsappInvoicePayment.forEach(CRMWhatsappInvoice => {
            CRMWhatsappInvoice.CRMWhatsappInvoiceAmount = Math.round(CRMWhatsappInvoice.CRMWhatsappInvoiceAmount / 5) * 5;
          });
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView_error', 'error', 'Ha ocurrido un error inesperado al consultar los pagos por SINPE activos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView = false;
      },

      connectWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice = async (websocketMessageData) => {
          this.display.CRMWhatsappInvoicePayment = this.display.CRMWhatsappInvoicePayment.filter(CRMWhatsappInvoice => CRMWhatsappInvoice.CRMWhatsappInvoiceID != websocketMessageData.websocketMessageContent.CRMWhatsappInvoiceID);
        };
        if (this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice){
          websocket.addWebsocketMessageListener('/SINPEPayment/functions/confirmSINPEPaymentForCRMWhatsappInvoice', this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice);
        }
      },

      disconnectWebsocket(){
        if (this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice) websocket.removeWebsocketMessageListener('/SINPEPayment/functions/confirmSINPEPaymentForCRMWhatsappInvoice', this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice);
        this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice = null;
      },

      async getSystemInformation() {
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){ 
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.getSystemInformationData = false;
      }
    },

    async mounted() {
      await this.getSystemInformation();
      await this.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView(true);
      this.$generalFunctions.default.focusInput(this, 'searchQuery');
      this.connectWebsocket();
      this.interval.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewInterval = setInterval(() => {
        this.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentView(false);
      }, 30000);
    },

    beforeUnmount() {
      if (this.interval.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewInterval){
        clearInterval(this.interval.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewInterval);
        this.interval.selectCRMWhatsappInvoicePaymentFromCurrentCRMWhatsappInvoicePaymentViewInterval = null;
      }
      this.disconnectWebsocket();
    }
  }
</script>